// import external dependencies

import "jquery"

// Import everything from autoload


import "./modules/rsvp";

jQuery(document).ready(() => {

	function marginContent() {
		const headerEl = $('.header-footer-group.header');
		const headerElHeight = headerEl.outerHeight();
		const mainEl = $('#site-content, .tribe-common, main');
		mainEl.css('margin-top', headerElHeight);
	}

	function shrinkHeader() {
		const headerEl = $('.header-footer-group.header');
		const wpElHeight = $('#wpadminbar').outerHeight();
		let topEl = $(window).scrollTop();

		if ($(document).scrollTop() > 0) {
			headerEl.addClass('sticky');
		} else {
			headerEl.removeClass('sticky');
		}

		if ($(window).width() < 601) {
			if (topEl < wpElHeight) {
				let topStyle = wpElHeight - topEl;
				headerEl.css('top', topStyle);
			} else {
				headerEl.css('top', '0');
			}
		} else {
			headerEl.removeAttr("style");
		}

	}

	function fixedHeaderModal() {

		const modalEl = $('.menu-modal.header-footer-group');
		const toggleEl = $('.nav-toggle.mobile-nav-toggle');

		if ($(window).width() < 1000) {
			if (modalEl.is(".show-modal, .active")) {
				modalEl.removeClass("show-modal, active");
			}
			if (toggleEl.is(".active")) {
				modalEl.removeClass("active");
			}
		}
	}

	function footerFixed() {

		let wHeigth = $(window).height();
		let wpElHeight = $('#wpadminbar').outerHeight();
		let contentEl = $('main, .tribe-common, #site-content');
		let fEl = $('#site-footer');
		let fHeight = fEl.outerHeight();

		let cHeight = wHeigth - (wpElHeight + fHeight);

		contentEl.css('min-height', cHeight)

	}

	marginContent();
	footerFixed();

	$(window).on("scroll resize", function () {
		shrinkHeader();
	});

	$(window).on("resize", function () {
		fixedHeaderModal();
		footerFixed();
	});

	const errorMess = $(".rsvp-oi-error-message");
	const errorOverlay = $(".rsvp-oi-error-message-wrap");

	$(document).click(function (e) {
		if (!$(e.target).is(errorMess) && $(e.target).is(errorOverlay)) {
			errorMess.animate({opacity: "0"}, 100, function () {
				errorOverlay.fadeOut(300);
			});
			$("body").css("overflow-y", "scroll");
		}
	});

	$('.rsvp-popup-wrap input').each(function () {
		$(this).attr("readonly", true);
	});


	// validate user OI ID before register if ID entered
	$('form.register .ur-submit-button').on('click', function (e) {
		const oiId = $('[data-id="oi_id"]').val();

		if (oiId) { // if OI ID not empty
			// disable default form action
			e.preventDefault();
			e.returnValue = false;

			// gather info needed to validate
			const email = $('[data-id="user_email"]').val();

			// if we have enough info
			if (oiId && email) {
				const data = {
						'action': 'check_oi_id',
						'oi-id': oiId,
						'email': email,
					},
					$form = $(this);
				$.ajax({
					type: 'POST',
					url: themeVars.ajaxurl,
					data: data,
					dataType: 'json',
					context: $form,
					success: function (response) { // were able to perform check
						if (response.success) {
							// OI ID validated
							this.off('submit');
							this.submit();
						} else {
							// OI ID not validated
							alert("we can't find associate with provided Email and OI ID. Please, double check entered info.");
						}
					},
					error: function () { // couldn't access associate list to validate
						alert("We can't validate your OI ID at the moment. Please, clear OI OD field and proceed to register as normal user.");
					},
				});
			} else {
				alert("Please, enter Email and OI ID to register or as Associate or leave OI ID field blank to register as normal user.");
			}
		}
	});

	$('form#rsvp-now button.tribe-button--rsvp').on('click', function () {
		$(this).addClass('disabled');
	});
});



// WEBPACK FOOTER //
// ./scripts/main.js